import { gql } from '@apollo/client';

const Fragments = {
  financialIndicatorItem: gql`
    fragment financialIndicatorItem on FinancialIndicatorItem {
      id
      orderNo
      code
      name
      attributeName
      expression
      comment
      externalCode
      styleId
      scale
      readOnly
      sensitiveInfo
    }
  `
};

export default Fragments;
